import { Component } from '@angular/core';
import { BaseRow } from '../base-row';

@Component({
  selector: 'app-recovery-row',
  templateUrl: './recovery-row.component.html',
    styleUrls: ['./../base-row.component.scss'],
    standalone: false
})
export class RecoveryRowComponent extends BaseRow {

}
